/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Export_Include_SuspendedInputs */



/**
* | output |
* | --- |
* | "Include suspended customers" |
*
* @param {Admin_Export_Include_SuspendedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_export_include_suspended = /** @type {((inputs?: Admin_Export_Include_SuspendedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Export_Include_SuspendedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gesperrte Kunden einschließen")
	return /** @type {LocalizedString} */ ("Include suspended customers")
});